import { PayloadAction } from "@reduxjs/toolkit";
import { IErrorHistoryItem } from "../../domain/model";

export function addErrorHistoryItemReducer(
  state,
  action: PayloadAction<IErrorHistoryItem>,
) {
  state.error.push(action.payload);
}
export function removeErrorHistoryItemReducer(state, action: PayloadAction<string>) {
  state.error = state.error.filter((item) => item.entityId !== action.payload);
}
